.wrapper {
  overflow-x: auto;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
}

.table {
  inline-size: 100%;
  font-size: var(--text-sm);
}

.caption {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.table th {
  padding: var(--space-2) var(--space-3);
  border-block-end: var(--border-width) solid var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
  font-weight: var(--weight-medium);
  text-align: start;
}

.table td {
  padding: var(--space-2) var(--space-3);
  border-block-end: var(--border-width) solid var(--color-border);
  vertical-align: baseline;
}

.table tbody tr:last-child td {
  border-block-end: 0;
}

.num {
  text-align: end;
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.table th.num {
  text-align: end;
}

.markerCell {
  inline-size: var(--space-8);
  text-align: center;
}

.marker {
  font-family: var(--font-mono);
  font-weight: var(--weight-semibold);
}

.row[data-status="added"] {
  background: var(--color-success-subtle);
}

.row[data-status="added"] .marker,
.row[data-status="added"] .after {
  color: var(--color-success);
}

.row[data-status="removed"] {
  background: var(--color-danger-subtle);
}

.row[data-status="removed"] .marker,
.row[data-status="removed"] .before {
  color: var(--color-danger);
}

.row[data-status="removed"] .label {
  text-decoration: line-through;
  text-decoration-color: var(--color-danger);
}

.row[data-status="changed"] {
  background: var(--color-warning-subtle);
}

.row[data-status="changed"] .marker {
  color: var(--color-warning);
}

.row[data-status="changed"] .after {
  font-weight: var(--weight-semibold);
}

.row[data-status="unchanged"] {
  color: var(--color-text-muted);
}

.delta {
  color: var(--color-text-muted);
}

.note {
  color: var(--color-text-subtle);
  text-align: center;
}
